import CashTransferBase from './base/CashTransferBase';
import CashTransferTypeEnum from './enum/CashTransferTypeEnum';

/**
 * @class CashTransfer
 * @extends CashTransferBase
 */
class CashTransfer extends CashTransferBase {
  get typeDisplayName() {
    switch (this.type) {
      case CashTransferTypeEnum.WITHDRAWAL_FROM_BANK:
      case CashTransferTypeEnum.WITHDRAWAL_FROM_VAULT:
        return 'Withdrawal'
      case CashTransferTypeEnum.DEPOSIT_TO_BANK:
      case CashTransferTypeEnum.DEPOSIT_TO_VAULT:
        return 'Deposit'
      case CashTransferTypeEnum.BETWEEN_COLLECTORS:
        return 'Between Collectors'
      case CashTransferTypeEnum.RT_FILL:
        return 'Fill'
      default:
        return this.type
    }
  }
}

export default CashTransfer;
